var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dialog-qr-login"},[_c('iframe',{attrs:{"sandbox":"allow-scripts allow-same-origin allow-top-navigation allow-popups","scrolling":"no","width":"300","height":"300","frameBorder":"0","allowTransparency":"true","src":_vm.setSrc}})])
}
var staticRenderFns = []

export { render, staticRenderFns }